import initFlipdownCountdown from './modules/countdown';

function initChapterCountdown() {
    var eventId = window.nextEventId;
    var targetUtc = window.workshopStartDateUtc;

    if (!eventId || !targetUtc) {
        return;
    }

    var elementId = 'flipdown-' + eventId;
    var element = document.getElementById(elementId);

    if (!element) {
        return;
    }

    var targetMs = Date.parse(targetUtc);

    if (Number.isNaN(targetMs) || targetMs <= Date.now()) {
        element.style.display = 'none';
        return;
    }

    initFlipdownCountdown({
        elementId: elementId,
        targetUtc: targetUtc,
        locale: window.currentLanguage || 'en',
        onEnd: function() {
            location.reload();
        },
        theme: 'dark',
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChapterCountdown);
} else {
    initChapterCountdown();
}
